import views from '../../../views/duck/reducers'
import {
  dataReducer,
  snackbarReducer,
  profileReducer
} from '../../duck/reducers'
import { combineReducers } from 'redux'

export const rootReducer = combineReducers({
  profile: profileReducer,
  views,
  data: dataReducer,
  snackbar: snackbarReducer
})



// WEBPACK FOOTER //
// ./src/core/store/reducers/index.ts